import Ambulatori from "../";

const routes = [
    { name: "AmbulatoriList", path: "/ambulatori", component: Ambulatori.AmbulatoriList, meta: { title: "ambulatori.lblTitle" } },
    { name: "AmbulatorioView", path: "/ambulatorio/view/:id", component: Ambulatori.AmbulatorioView, meta: { title: "ambulatori.lblTitle" } },
    { name: "AmbulatorioEdit", path: "/ambulatorio/edit/:id", component: Ambulatori.AmbulatorioEdit, meta: { title: "ambulatori.lblTitle" } },
];

export default routes;
